import { Injectable } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { DamageTypeInterface } from './definitions/damage-type.interface';

interface GetAllDamageTypesResponse {
  taskTag: {
    list: {
      output: Array<DamageTypeInterface>;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class GetAllDamageTypesService {
  constructor(private apollo: Apollo) {}

  public getAll(query: DocumentNode): QueryRef<GetAllDamageTypesResponse> {
    return this.apollo.watchQuery<GetAllDamageTypesResponse>({
      query: query,
      fetchPolicy: 'network-only',
    });
  }
}
